export default "__VITE_ASSET__72bb2c9c__"